// extracted by mini-css-extract-plugin
export default {"container":"vertical_container__lG6R1","item":"vertical_item__JiH6M"};